<template>
  <el-dialog
    width="320px"
    top="10%"
    :visible.sync="options.visible"
    @close="tipMsgClose"
    append-to-body
    class="tip-messages"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <iframe
      style="position: absolute; z-index: -1; width: 100%; height: 100%; top: 0;left:0;scrolling:no;"
      frameborder="0"
    ></iframe>
    <div class="tip-msg-box">
      <center v-if="options.showImg">
        <img v-bind:src="options.imgSrc" width="96px" />
      </center>
      <h3 class="Font_size_24 text-center" :class="options.msgClass">
        {{ options.msg }}
      </h3>
      <p class="Font_size_16 text-center" v-if="options.showDesp">
        {{ options.desp }}
      </p>
      <div class="text-center">
        <el-button :type="options.btnType" round @click="tipMsgOK">{{
          options.btnTitle
        }}</el-button>
        <el-button
          :type="options.btnCancelType"
          v-if="options.showCancelBtn"
          round
          @click="tipMsgCancel"
          style="margin-left:10px;"
          >{{ options.btnCancelTitle }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      options: {
        showType: 0, // 0：表单提交成功 1：表单提交失败 2：自定义样式
        showImg: true,
        imgSrc: "../../../../static/img/tijiao.png",
        visible: false,
        msg: "恭喜您，提交成功！",
        msgClass: "tip-text-color-green",
        showDesp: false,
        desp: "稍后请在列表查看结果",
        btnType: "greens",
        btnTitle: "确 定",
        showCancelBtn: false,
        btnCancelType: "orgin",
        btnCancelTitle: "取 消"
      }
    };
  },
  props: ["userOptions"],
  methods: {
    tipMsgClose: function() {
      this.options.visible = false;
      this.$emit("tipMsgClose", this.options.visible);
    },
    tipMsgOK: function() {
      this.options.visible = false;
      this.$emit("tipMsgOK", this.options.visible);
    },
    tipMsgCancel: function() {
      this.options.visible = false;
      this.$emit("tipMsgCancel", this.options.visible);
    }
  },
  mounted() {
    //console.log(this.userOptions);
    if (this.userOptions.showType == 1) {
      this.options.imgSrc = "../../../../static/img/del.png";
      this.options.msg = "糟糕，提交失败！";
      this.options.msgClass = "tip-text-color-red";
      this.options.desp = "您可以稍后重新操作";
      this.options.btnType = "reds";
      this.options.btnTitle = "确 定";
    } else if (this.userOptions.showType == 3) {
      this.options.imgSrc = "../../../static/img/wenhao.png";
      this.options.msg = "是否删除此条数据？";
      this.options.msgClass = "tip-text-color-blue";
      this.options.desp = "删除后不可恢复";
      this.options.btnType = "blues";
      this.options.showCancelBtn = true;
    } else if (this.userOptions.showType == 2) {
      this.options.imgSrc = "../../../static/img/gantanhao.png";
      this.options.msg = "请选择一条数据！";
      this.options.msgClass = "tip-text-color-yellow";
      this.options.desp = "数据未选或选择多条";
      this.options.btnType = "yellows";
      this.options.showCancelBtn = false;
    }
    this.options = Object.assign(this.options, this.userOptions);
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/tipMsgDialog.vue